import {
  ImagesSkusHouseSvg,
  ImagesSkusArrowRightSvg,
} from '@/assets/images_skus.assets';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
export default function SkusMobileBreadCrumbs() {
  const pathname = usePathname();

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <Link href="/search">
        <Image
          src={ImagesSkusHouseSvg}
          width={12}
          height={12}
          alt="house"
          className="mb-1"
        />
      </Link>
      {(pathname || '').split('/').filter((path) => {
        return (
          path !== '' &&
          path !== 'category' &&
          path !== 'region' &&
          path !== 'search' &&
          path !== 'brands' &&
          path !== 'country'
        );
      }).length > 0 && (
        <Image src={ImagesSkusArrowRightSvg} width={4} height={9} alt="arrow" />
      )}
      {pathname
        ?.split('/')
        .filter((path) => {
          return (
            path !== '' &&
            path !== 'category' &&
            path !== 'region' &&
            path !== 'search' &&
            path !== 'brands' &&
            path !== 'country'
          );
        })
        .map((path, index) => (
          <>
            <Link
              className={clsx(
                'tw-font-plusJakartaSans tw-font-medium tw-text-xs tw-no-underline',
                {
                  ['tw-text-slate-gray']:
                    index !== pathname?.split('/').length - 2,
                  ['tw-text-text']: index === pathname?.split('/').length - 2,
                }
              )}
              key={path}
              href={(pathname || '')
                .split('/')
                .slice(0, index + 2)
                .join('/')}
            >
              {path}
            </Link>
            <Image
              src={ImagesSkusArrowRightSvg}
              width={4}
              height={9}
              alt="arrow"
            />
          </>
        ))}
    </div>
  );
}
